<template>
  <div>
    <v-btn
      class="icon-btn"
      elevation="1"
      color="primary"
      @click="$emit('export-csv')"
    >
      <font-awesome-icon
        :icon="['fas', 'file-export']"
      />
      Export
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'ExportList',
  }
</script>
